export enum FieldType {
  SELECT = "select",
  BOOLEAN = "boolean", 
  NUMBER = "number",
  TEXT = "text",
  DATE = "date",
  MULTISELECT = "multiselect"
}

export interface SpecificationSchema {
  id: string;
  companyId: string;
  displayName: string;
  fieldName: string;
  fieldType: FieldType;
  options?: string[] | null;
  isRequired: boolean;
}

export interface SpecificationSchemaCreate {
  displayName: string;
  fieldName: string;
  fieldType: FieldType;
  options?: string[] | null;
  isRequired?: boolean;
}

export interface SpecificationSchemaUpdate {
  displayName?: string;
  fieldName?: string;
  fieldType?: FieldType;
  options?: string[] | null;
  isRequired?: boolean;
}